import React, { useEffect, useState, useRef } from "react";
import { Grid, Button, Modal, Drawer, Divider, Slider } from "@mui/material";
import { Filters } from "../../components";
import { experimentalStyled as styled } from "@mui/material/styles";
import tokenIds from "../../assets/heroesData/TraitToId_V5.json";
import metadata from "../../assets/heroesData/HeroesMetaData.json";
import FilterListIcon from "@mui/icons-material/FilterList";
import Fade from "@mui/material/Fade";
import { useMediaQuery } from "@mui/material";
import ShuffleIcon from "@mui/icons-material/Autorenew";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import ItemsCarousel from "react-items-carousel";
import { Carousel } from "react-responsive-carousel";

import "./style.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import {
  traitsOrder,
  traitsMapping,
} from "../../assets/heroesData/TraitEncodingHeroes.js";
import InfiniteScroll from "react-infinite-scroll-component";
import intersection from "lodash.intersection";
import shuffle from "lodash.shuffle";
const StyledActiveFilter = styled(Button)`
  border-radius: 9999px;
  border: 1px solid white;
  padding: 12px 15px;
  color: white;
  height: 15px;
  font-size: 12px;
  margin-right: 5px;
`;

const StyledModalTrait = styled("div")({
  borderRadius: "5px",
  border: "1px solid #ffb631 ",
  padding: "15px",
  color: "white",
  background: "rgba(255,255,255,0.08)",
  display: "flex",
  flexDirection: "column",
});
const Collection = () => {
  const [activeFilters, setActiveFilters] = useState([]);
  const [collection, setCollection] = useState([]);
  const [removedFilter, setRemovedFilter] = useState({});
  const [paginatedCollection, setPaginatedCollection] = useState([]);
  const [foundSingleToken, setFoundSingleToken] = useState(null);
  const [limit, setLimit] = useState(40);
  const [modalData, setModalData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [searchedTokenId, setSearchedTokenId] = useState(null);
  const [scoreSorted, setScoreSorted] = useState(false);

  const [heroLevelValues, setHeroLevelValues] = useState([10, 50]);
  const matchesExtraBig = useMediaQuery(
    "(max-width:1700px) and (min-width:1401px)",
    { noSsr: true }
  );
  const matchesBig = useMediaQuery(
    "(max-width:1400px) and (min-width:1201px) ",
    { noSsr: true }
  );

  const matchesMedium = useMediaQuery(
    "(max-width:1200px) and (min-width:1025px)",
    { noSsr: true }
  );
  const matchesSmall = useMediaQuery("(max-width:1024px)", { noSsr: true });
  const matchesExtraSmall = useMediaQuery("(max-width:800px)", { noSsr: true });
  const matchesSmallMobile = useMediaQuery("(max-width:400px)", {
    noSsr: true,
  });
  const handleSetActiveFilters = (activefilters) => {
    setActiveFilters(activefilters);
  };
  const fetchMoreData = () => {
    setLimit((prevLimit) => prevLimit + 40);
  };
  const setSearchByTokenIdHandler = (id) => {
    setSearchedTokenId(id);
  };
  const handleRemoveActiveFilter = (index) => {
    setRemovedFilter(activeFilters[index]);
    setActiveFilters(activeFilters.filter((item, i) => i !== index));
  };
  const handleShuffle = () => {
    const shuffledCollection = shuffle(collection);
    setCollection(shuffledCollection);
    if (paginatedCollection.length < 20) {
      setPaginatedCollection(shuffledCollection.slice(0, 20));
    } else {
      setPaginatedCollection(
        shuffledCollection.slice(0, paginatedCollection.length - 1)
      );
    }
  };
  const toggleScoreSorted = () => {
    const negateSort = !scoreSorted;

    if (negateSort) {
      const sortedCollection = collection.sort(function (a, b) {
        return b[0][1] - a[0][1];
      });
      setCollection(sortedCollection);
      setPaginatedCollection(sortedCollection.slice(0, 20));
    } else {
      const sortedCollection = collection.sort(function (a, b) {
        return a[0][0] - b[0][0];
      });
      setCollection(sortedCollection);
      setPaginatedCollection(sortedCollection.slice(0, 20));
    }
    setScoreSorted(negateSort);
  };
  useEffect(() => {
    if (searchedTokenId) {
      const found = collection.find(
        (item) => item[0][0] === parseInt(searchedTokenId)
      );
      if (found) {
        setFoundSingleToken(found);
      } else {
        setFoundSingleToken([]);
      }
    } else {
      setFoundSingleToken(null);
    }
  }, [searchedTokenId, collection]);
  useEffect(() => {
    setPaginatedCollection(collection.slice(0, limit));
  }, [limit]);
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };
  useEffect(() => {
    if (activeFilters.length !== 0) {
      const unfilteredCollection = activeFilters.reduce((a, b) => {
        let trait;
        let traitValue;
        let ids;

        if (Object.keys(b)[0] === "HERO LEVEL") {
        } else {
          trait = Object.keys(b)[0];
          traitValue = b[trait];
        }

        //multiple levels
        if (Array.isArray(tokenIds[trait][traitValue][0])) {
          // from lvl 1 to 8
          if (b["LVL"]) {
            if (tokenIds[trait][traitValue][b["LVL"] - 1]) {
              ids = tokenIds[trait][traitValue][b["LVL"] - 1];
            }
          } else {
            //lvl 0 - the higher level
            ids = tokenIds[trait][traitValue].flat();
          }
        } else {
          ids = tokenIds[trait][traitValue];
        }

        if (a[trait]) {
          if (ids) {
            return { ...a, [trait]: [...a[trait].flat(), ids].flat() };
          } else {
            return { ...a, [trait]: [...a[trait].flat()].flat() };
          }
        } else {
          return { ...a, [trait]: ids };
        }
      }, []);
      const intersectionArray = intersection(
        ...Object.values(unfilteredCollection)
      );

      let intersectionMetaData = intersectionArray.map((id) => {
        return metadata[id - 1];
      });
      if (scoreSorted) {
        intersectionMetaData = intersectionMetaData.sort(function (a, b) {
          return b[0][1] - a[0][1];
        });
      }
      setCollection(intersectionMetaData);
      setPaginatedCollection(intersectionMetaData.slice(0, 20));
    } else {
      setCollection(
        [
          ...tokenIds["archetype"]["Le Anime"],
          ...tokenIds["archetype"]["Spirit"],
        ].map((id) => {
          return metadata[id - 1];
        })
      );
      setPaginatedCollection(
        [
          ...tokenIds["archetype"]["Le Anime"],
          ...tokenIds["archetype"]["Spirit"],
        ]
          .map((id) => {
            return metadata[id - 1];
          })
          .slice(0, 20)
      );
    }
  }, [activeFilters]);
  const encodeMetaData = (hero) => {
    const formattedHero = hero.map((cell, i) => {
      return cell.map((traitNo, k) => {
        let formattedTrait;
        if (i === 0) {
          // skip TOKEN ID , put Score, Rank
          if (k >= 0 && k <= 2) {
            formattedTrait = { [traitsOrder[0][k]]: traitNo };
          } else if (
            // [RUNES, Runes Level, runes Visual level]
            k ===
            cell.length - 1
          ) {
            formattedTrait = {
              Runes: `${traitsMapping[k - 3][traitNo[0]]} LVL ${traitNo[1]} `,
              RunesVislLVL: traitNo[2],
            };
          } else {
            formattedTrait = {
              [traitsOrder[0][k]]: traitsMapping[k - 3][traitNo],
            };
          }
          return formattedTrait;
        }

        if (i === 1) {
          formattedTrait = {
            [`Extra ${k + 1}`]: `${
              traitsMapping[traitsMapping.length - 1][traitNo[0]]
            } LVL ${traitNo[1]}`,
            ExtraVislLVL: traitNo[2],
          };
        }
        return formattedTrait;
      });
    });
    return formattedHero.flat();
  };
  useEffect(() => {
    // console.log(collection);
  }, []);
  const handleOpen = (id) => {
    const ids = metadata[id - 1];
    const encodedMetadata = encodeMetaData(ids);

    setModalData({
      data: encodedMetadata.slice(1, encodedMetadata.length),
      id,
    });

    setOpenModal(true);
  };
  const handleClose = () => {
    setOpenModal(false);
  };
  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      style={{
        paddingTop:
          matchesMedium || (matchesSmall && activeFilters?.length >= 1)
            ? "120px"
            : "90px",
        width: "100%",
      }}
    >
      {" "}
      {matchesSmall && (
        <Drawer
          disableScrollLock={true}
          open={drawerOpen}
          anchor="left"
          onClose={toggleDrawer}
          variant="temporary"
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: "60%", padding: "20px", background: "#111111" },
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",

              color: "white",
              display: "flex",
              flexDirection: "row",
              justifyContent: "start",
              alignItems: "start",
            }}
          >
            <div style={{ position: "absolute", right: 10, top: 30 }}>
              {matchesSmall && <ShuffleIcon onClick={handleShuffle} />}
              {matchesSmall && (
                <FilterListIcon
                  style={{
                    transform: !scoreSorted ? "rotate(0)" : "rotate(180deg)",
                  }}
                  onClick={toggleScoreSorted}
                />
              )}
            </div>
            <Filters
              setSearchByTokenId={setSearchByTokenIdHandler}
              handleSetActiveFilters={handleSetActiveFilters}
              removedFilter={removedFilter}
            />
          </div>
        </Drawer>
      )}
      <Modal
        disableScrollLock={true}
        style={{ border: "none" }}
        open={openModal}
        onClose={handleClose}
      >
        <Fade in={openModal}>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: matchesExtraSmall
                ? "90%"
                : matchesSmall
                ? "60%"
                : matchesMedium
                ? "90%"
                : "1200px",
              background: "#111111",
              display: "flex",
              flexDirection: matchesSmall ? "column" : "row",
              justifyContent: "space-between",
              alignItems: "center",
              borderRadius: "10px",
              outline: "none",
            }}
          >
            <img
              src={`https://leanime.art/heroes/m/${modalData.id}.jpg`}
              style={{
                height: matchesSmall
                  ? "auto"
                  : matchesMedium
                  ? "auto"
                  : "500px",
                maxWidth: matchesSmall ? "100%" : "50%",
              }}
            />
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems={matchesSmall ? "center" : "start"}
              style={{
                width: matchesSmall ? "100%" : matchesMedium ? "50%" : "100%",
                padding: "20px 20px",
              }}
            >
              <div
                style={{
                  color: "white",
                  display: "flex",
                  justifyContent: matchesSmall
                    ? "space-around"
                    : "space-between",
                  alignItems: "center",
                  width: matchesSmall ? "90%" : "97%",
                  marginBottom: "4%",
                  fontSize: matchesMedium || matchesSmall ? "20px" : "32px",
                  fontFamily: "EurostilDemi",
                }}
              >
                <span style={{ marginRight: matchesSmall ? "0px" : "20px" }}>
                  {modalData.id < 1573
                    ? `Le Anime #${modalData.id}`.toUpperCase()
                    : `Spirit #${modalData.id}`.toUpperCase()}
                </span>{" "}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <a
                    style={{
                      color: "white",
                      textDecoration: "none",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    target="_blank"
                    href={`https://opensea.io/assets/ethereum/0x03bebcf3d62c1e7465f8a095bfa08a79ca2892a1/${
                      modalData.id + 100000
                    }`}
                  >
                    <svg
                      height="20"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="white"
                      viewBox="0 0 40 40"
                    >
                      <path d="M20 1C9.508 1 1 9.508 1 20s8.508 19 19 19 19-8.508 19-19S30.496 1 20 1Zm-9.625 19.638.08-.129 4.943-7.733c.072-.11.243-.099.297.023.824 1.85 1.539 4.153 1.204 5.586-.14.589-.532 1.387-.973 2.124a3.808 3.808 0 0 1-.186.316.168.168 0 0 1-.14.072h-5.081a.168.168 0 0 1-.144-.259Zm22.028 2.66a.172.172 0 0 1-.102.16c-.384.163-1.695.768-2.239 1.524-1.39 1.934-2.45 4.7-4.826 4.7h-9.902c-3.512 0-6.354-2.853-6.354-6.376v-.114a.17.17 0 0 1 .171-.167h5.518c.11 0 .19.099.182.209-.042.357.027.726.198 1.06a1.94 1.94 0 0 0 1.74 1.08h2.732V23.24H16.82a.175.175 0 0 1-.14-.273 20.887 20.887 0 0 0 1.083-1.714c.247-.433.486-.897.68-1.36.038-.084.068-.171.103-.255.053-.148.106-.289.144-.426.038-.117.072-.239.103-.353.09-.395.129-.813.129-1.246 0-.171-.008-.35-.023-.517a6.939 6.939 0 0 0-.053-.559c-.015-.163-.046-.327-.076-.494a10.282 10.282 0 0 0-.156-.74l-.023-.096c-.045-.17-.087-.33-.14-.501a18.721 18.721 0 0 0-.521-1.54 8.252 8.252 0 0 0-.224-.562c-.114-.281-.232-.536-.338-.775a5.642 5.642 0 0 1-.149-.312c-.053-.114-.106-.228-.163-.338-.038-.083-.084-.163-.114-.24l-.334-.615c-.046-.083.03-.186.121-.16l2.09.567h.015l.274.08.304.083.11.03V9.688c0-.6.479-1.087 1.076-1.087.296 0 .566.122.756.32.194.197.315.467.315.767v1.843l.224.06c.016.008.035.016.05.027.053.038.133.099.232.175.08.06.163.137.262.217.201.163.444.372.707.611.068.061.136.122.201.187.338.315.718.684 1.083 1.094.103.118.201.232.304.357.099.126.209.247.3.369.126.163.255.334.373.513.053.083.117.17.167.254.152.225.281.456.406.688.054.107.107.224.152.338.141.312.251.627.32.947.022.068.038.14.045.209v.015c.023.091.03.19.038.292.03.323.015.65-.053.977a4.37 4.37 0 0 1-.114.407c-.05.133-.095.27-.156.402-.118.27-.254.544-.418.795-.053.095-.118.193-.178.288-.069.1-.141.194-.202.285a6.16 6.16 0 0 1-.273.35c-.084.114-.168.228-.263.33-.129.156-.254.3-.387.441-.076.092-.16.187-.247.27-.084.095-.171.179-.247.255-.133.133-.24.232-.33.319l-.217.194a.16.16 0 0 1-.114.045h-1.665v2.132h2.094c.467 0 .912-.163 1.273-.471.122-.106.657-.57 1.292-1.27a.15.15 0 0 1 .08-.049l5.78-1.672a.17.17 0 0 1 .216.164v1.223Z"></path>
                    </svg>
                  </a>
                </div>
              </div>
              {matchesMedium || matchesSmall ? (
                <div
                  style={{
                    padding: "0 0",
                    color: "white",
                    width: "100%",
                  }}
                >
                  <Carousel
                    centerMode
                    showThumbs={false}
                    showStatus={false}
                    centerSlidePercentage={matchesExtraSmall ? 90 : 40}
                    showInidcators={true}
                    showArrows={false}
                    emulateTouch
                    renderIndicator={(
                      onClickHandler,
                      isSelected,
                      index,
                      label
                    ) => {
                      if (isSelected) {
                        return (
                          <li
                            style={{
                              cursor: "pointer",
                              background: "#ffb631 ",
                              width: matchesExtraSmall ? 8 : 12,
                              height: matchesExtraSmall ? 4 : 6,
                              display: "inline-block",
                              margin: matchesExtraSmall ? "0 2px" : "0 5px",
                            }}
                            aria-label={`Selected: ${label} ${index + 1}`}
                            title={`Selected: ${label} ${index + 1}`}
                          />
                        );
                      }
                      return (
                        <li
                          style={{
                            background: "#fff",
                            cursor: "pointer",
                            width: matchesExtraSmall ? 8 : 12,
                            height: matchesExtraSmall ? 4 : 6,
                            display: "inline-block",
                            margin: matchesExtraSmall ? "0 2px" : "0 5px",
                          }}
                          onClick={onClickHandler}
                          onKeyDown={onClickHandler}
                          value={index}
                          key={index}
                          role="button"
                          tabIndex={0}
                          title={`${label} ${index + 1}`}
                          aria-label={`${label} ${index + 1}`}
                        />
                      );
                    }}
                  >
                    {modalData?.data &&
                      modalData.data.map((d, i) => (
                        <div style={{ height: "100%", width: "100%" }}>
                          <StyledModalTrait
                            style={{
                              width: "98%",
                            }}
                            key={i}
                          >
                            <span
                              style={{
                                fontFamily: "EurostilCond",
                                letterSpacing: "0.3em",
                                fontWeight: "100",
                                color: "#ffb631 ",
                                fontSize: "9px",
                                marginBottom: "5px",
                              }}
                            >
                              {Object.keys(d)[0].toString().toUpperCase()}
                            </span>
                            <span
                              style={{
                                fontFamily: "EurostilDemi",
                                fontSize: "12px",
                                letterSpacing: "0.02em",
                              }}
                            >
                              {Object.values(d)[0].toString().toUpperCase()}
                            </span>
                          </StyledModalTrait>
                          <div style={{ height: "30px" }}></div>
                        </div>
                      ))}
                  </Carousel>
                  <div
                    style={{
                      position: "absolute",
                      bottom: matchesSmall ? 10 : 40,
                      right: matchesSmall ? 15 : 50,
                      color: "white",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <a
                      target="_blank"
                      href={`https://leanime.mypinata.cloud/ipfs/QmT7NX6NMr4Z7GDRQ14R2cNsafq56eca1ic8X1vyhGMpva/${modalData.id}.jpg`}
                      style={{
                        color: "grey",
                        fontFamily: "EurostilDemi",
                        fontSize: "15px",
                        letterSpacing: "0.02em",
                        textDecoration: "none",
                      }}
                    >
                      VIEW HIGH RES
                    </a>
                  </div>
                </div>
              ) : (
                <Grid
                  container
                  component={"div"}
                  direction="row"
                  spacing={1}
                  justifyContent={matchesMedium ? "start" : "center"}
                  alignItems={matchesMedium ? "start" : "center"}
                  style={{
                    width: "100%",
                  }}
                >
                  {modalData?.data &&
                    modalData.data.map((d) => (
                      <Grid component={"div"} item xs={4}>
                        <StyledModalTrait>
                          <span
                            style={{
                              fontFamily: "EurostilCond",
                              letterSpacing: "0.3em",
                              fontWeight: "100",
                              color: "#ffb631 ",
                              fontSize: "9px",
                              marginBottom: "5px",
                            }}
                          >
                            {Object.keys(d)[0].toString().toUpperCase()}
                          </span>
                          <span
                            style={{
                              fontFamily: "EurostilDemi",
                              letterSpacing: "0.08em",
                              fontSize: "13px",
                            }}
                          >
                            {Object.values(d)[0].toString().toUpperCase()}
                          </span>
                        </StyledModalTrait>
                      </Grid>
                    ))}
                  <div
                    style={{
                      position: "absolute",
                      bottom: 40,
                      right: 50,
                      color: "white",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <a
                      target="_blank"
                      href={`https://leanime.mypinata.cloud/ipfs/QmT7NX6NMr4Z7GDRQ14R2cNsafq56eca1ic8X1vyhGMpva/${modalData.id}.jpg`}
                      style={{
                        color: "grey",
                        fontFamily: "EurostilDemi",
                        fontSize: "15px",
                        letterSpacing: "0.02em",
                        textDecoration: "none",
                      }}
                    >
                      VIEW HIGH RES
                    </a>
                  </div>
                </Grid>
              )}
            </Grid>
          </div>
        </Fade>
      </Modal>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="start"
        style={{ width: "95%" }}
      >
        {!matchesSmall && (
          <>
            {" "}
            <div
              style={{
                width: "25%",
                position: "fixed",
                top: matchesMedium ? 120 : 100,
                left: 25,
              }}
            >
              {/* <Slider
                getAriaLabel={() => "Hero Level"}
                value={heroLevelValues}
                onChange={(e, values) => {
                  setHeroLevelValues(values);
                }}
                valueLabelDisplay="auto"
              /> */}
              <Filters
                setSearchByTokenId={setSearchByTokenIdHandler}
                handleSetActiveFilters={handleSetActiveFilters}
                removedFilter={removedFilter}
              />
            </div>
            <div
              style={{
                width: "25%",
              }}
            ></div>
          </>
        )}
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="start"
          style={{
            width: matchesSmall ? "95%" : "75%",
            paddingLeft: matchesSmall ? 0 : "20px",
          }}
        >
          <div
            style={{
              position: matchesSmall ? "fixed" : "relative",
              top: matchesSmall ? 80 : 15,
              zIndex: matchesSmall ? 1 : 0,
              fontFamily: "PPNeueMachina",
              fontWeight: "900",
              width: matchesSmall ? "91%" : "100%",
              background: "#111111",
              zIndex: 0,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span
                  style={{
                    color: "#ffb631 ",
                    fontSize: matchesSmallMobile
                      ? "20px"
                      : matchesSmall
                      ? "25px"
                      : "32px",
                  }}
                >
                  LE ANIME
                </span>
                <span
                  style={{
                    fontSize: matchesSmallMobile
                      ? "20px"
                      : matchesSmall
                      ? "25px"
                      : "32px",
                  }}
                >
                  {" "}
                  //{" "}
                  {foundSingleToken
                    ? foundSingleToken.length > 0
                      ? 1
                      : 0
                    : collection.length}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: matchesSmall ? "10%" : "180px",
                }}
              >
                {!matchesSmall && (
                  <>
                    <Button
                      style={{
                        background: "#ffb631",
                        color: "black",
                        fontFamily: "EurostilDemi",
                        fontSize: "11px",
                        letterSpacing: "0.02em",
                      }}
                      onClick={handleShuffle}
                    >
                      SHUFFLE
                    </Button>
                    <Button
                      style={{
                        background: "#ffb631",
                        color: "black",
                        fontFamily: "EurostilDemi",
                        fontSize: "11px",
                        letterSpacing: "0.02em",
                      }}
                      onClick={toggleScoreSorted}
                    >
                      SORT BY {scoreSorted ? `ID` : `SCORE`}
                    </Button>{" "}
                  </>
                )}

                {matchesSmall && <FilterAltIcon onClick={toggleDrawer} />}
              </div>
            </div>
            <Divider
              style={{
                borderColor: "rgba(255, 182, 49,0.4)",
                marginBottom: "10px",
              }}
            />
            <Grid
              container
              direction="row"
              justifyContent="start"
              alignItems="center"
              style={{
                width: "100%",
                top: matchesSmall ? 100 : 0,
              }}
            >
              <div
                style={{
                  marginRight: "1%",
                  fontFamily: "EurostilDemi",
                  letterSpacing: "-0.01em",
                  marginBottom: "10px",
                }}
              >
                FILTERS (<span>{activeFilters.length}</span>){" "}
              </div>
              {activeFilters.length > 0 && (
                <div
                  style={{
                    overflowX: "auto",
                    width: matchesSmall ? "95%" : "100%",
                    padding: "5px 0 ",
                    whiteSpace: matchesSmall ? "nowrap" : "normal",
                  }}
                >
                  {activeFilters.map((af, i) => (
                    <StyledActiveFilter
                      onClick={() => handleRemoveActiveFilter(i)}
                      style={{
                        fontFamily: "EurostilDemi",
                        letterSpacing: "-0.01em",
                        background: af.hasOwnProperty("LVL")
                          ? "#ffb631 "
                          : "transparent",
                        borderColor: af.hasOwnProperty("LVL")
                          ? "#ffb631 "
                          : "white",
                        color: af.hasOwnProperty("LVL") ? "black" : "white",
                        marginBottom: "5px",
                      }}
                    >
                      <span style={{ width: "100%" }}>
                        {Object.keys(af)[0].toUpperCase()}:{" "}
                        {Object.values(af)[0].toUpperCase()}{" "}
                        {af["LVL"] && `LVL ${af["LVL"]}`}
                        {"     "}
                      </span>
                      <span
                        style={{
                          marginLeft: "10px",
                        }}
                      >
                        {" "}
                        X
                      </span>
                    </StyledActiveFilter>
                  ))}
                </div>
              )}
            </Grid>
          </div>

          {foundSingleToken ? (
            foundSingleToken.length > 0 ? (
              <Grid
                container
                direction="row"
                justifyContent="start"
                alignItems="center"
                style={{
                  width: "100%",
                  margin: matchesSmall ? "70px 0" : "20px 0",
                }}
              >
                <Grid
                  item
                  xs={
                    matchesSmall
                      ? 6
                      : matchesMedium
                      ? 4
                      : matchesBig
                      ? 3
                      : matchesExtraBig
                      ? 2.4
                      : 2
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "start",
                      alignItems: "start",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        borderRadius: "10px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={`https://leanime.art/heroes/m/${foundSingleToken[0][0]}.jpg`}
                        onClick={() => handleOpen(foundSingleToken[0][0])}
                        style={{
                          width: "100%",
                          height: "100%",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginTop: "4%",
                        lineHeight: "24px",
                        fontFamily: "EurostilDemi",
                        letterSpacing: "-0.01em",
                        fontSize: "13px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span>
                        {" "}
                        {foundSingleToken[0][0] < 1573
                          ? `Le Anime  #${foundSingleToken[0][0]}`
                          : `Spirit  #${foundSingleToken[0][0]}`}
                      </span>
                    </div>
                  </div>
                </Grid>
              </Grid>
            ) : (
              <></>
            )
          ) : (
            <div
              style={{
                display: "flex",
                width: "100%",
                margin: matchesSmall ? "70px 0" : "20px 0",
              }}
            >
              {" "}
              <TransitionGroup>
                {collection.length > 20 ? (
                  <InfiniteScroll
                    dataLength={paginatedCollection.length}
                    next={fetchMoreData}
                    hasMore={true}
                    style={{ width: "100%" }}
                    endMessage={
                      <p style={{ textAlign: "center" }}>
                        <b>Yay! You have seen it all</b>
                      </p>
                    }
                  >
                    <Grid
                      container
                      rowSpacing={2}
                      columnSpacing={matchesSmall ? 0 : 2}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="space-between"
                      style={{ width: "100%" }}
                    >
                      {" "}
                      {paginatedCollection.map((item, i) => (
                        <CSSTransition
                          in={true}
                          classNames="item"
                          timeout={20000}
                        >
                          <Grid
                            item
                            xs={
                              matchesSmall
                                ? 5.9
                                : matchesMedium
                                ? 4
                                : matchesBig
                                ? 3
                                : matchesExtraBig
                                ? 2.4
                                : 2
                            }
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "start",
                                alignItems: "start",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  width: "100%",
                                  borderRadius: "10px",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={`https://leanime.art/heroes/sm/${item[0][0]}.jpg`}
                                  onClick={() => handleOpen(item[0][0])}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    cursor: "pointer",
                                  }}
                                />
                              </div>
                              <div
                                style={{
                                  width: "100%",
                                  textAlign: "center",
                                  marginTop: "4%",
                                  lineHeight: "24px",
                                  fontFamily: "EurostilDemi",
                                  fontSize: "14px",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <span>
                                  {" "}
                                  {item[0][0] < 1573
                                    ? `Le Anime  #${item[0][0]}`.toUpperCase()
                                    : `Spirit  #${item[0][0]}`.toUpperCase()}
                                </span>
                              </div>
                            </div>
                          </Grid>
                        </CSSTransition>
                      ))}
                    </Grid>
                  </InfiniteScroll>
                ) : (
                  <CSSTransition in={true} classNames="item" timeout={20000}>
                    <Grid
                      container
                      spacing={2}
                      direction="row"
                      justifyContent="start"
                      alignItems="center"
                      style={{ width: "100%" }}
                    >
                      {" "}
                      {collection.map((item, i) => (
                        <Grid
                          item
                          xs={
                            collection.length === 1
                              ? matchesSmall
                                ? 9
                                : 7
                              : collection.length === 2
                              ? matchesSmall
                                ? 6
                                : 3.5
                              : collection.length === 3
                              ? matchesSmall
                                ? 6
                                : 2.4
                              : matchesSmall
                              ? 5.9
                              : matchesMedium
                              ? 4
                              : matchesBig
                              ? 3
                              : matchesExtraBig
                              ? 2.4
                              : 2
                          }
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "start",
                              alignItems: "start",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                borderRadius: "10px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={`https://leanime.art/heroes/sm/${item[0][0]}.jpg`}
                                onClick={() => handleOpen(item[0][0])}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  cursor: "pointer",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                width: "100%",
                                textAlign: "center",
                                marginTop: "4%",
                                lineHeight: "24px",
                                fontFamily: "EurostilDemi",
                                fontSize: "14px",
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span>
                                {" "}
                                {item[0][0] < 1573
                                  ? `Le Anime  #${item[0][0]}`.toUpperCase()
                                  : `Spirit  #${item[0][0]}`.toUpperCase()}
                              </span>
                            </div>
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                  </CSSTransition>
                )}
              </TransitionGroup>
            </div>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Collection;
